import { PERMISSIONS, ROLE_CONFIG_KEYS } from ".";

export const allPaymentPageRoutes = [
  {
    to: "/payments/outstanding",
    text: "Outstanding",
    permission: {
      config: ROLE_CONFIG_KEYS.outstanding,
      permission: PERMISSIONS.read
    }
  },
  {
    to: "/payments/history",
    text: "History",
    permission: {
      config: ROLE_CONFIG_KEYS.payment,
      permission: PERMISSIONS.read
    }
  }
];

export default {
  allPaymentPageRoutes
};
